export default class CookieService {
  static set (cookieName, value, daysUntilExpire = 365) {
    const d = new Date(); d.setTime(d.getTime() + (daysUntilExpire * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;

    if (typeof document !== 'undefined') {
      document.cookie = `${cookieName}=${value};${expires};path=/`;
    }
  }

  static get (cookieName, defaultValue = null) {
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return defaultValue;
  }
}
